module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summaryRegex"
  }, [_vm._l((_vm.value), function(regex, index) {
    return _c('div', [_c('div', {
      staticClass: "field mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('input', {
      ref: 'summary_' + index,
      refInFor: true,
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "id": 'summary_' + index,
        "required": _vm.required
      },
      domProps: {
        "value": regex
      },
      on: {
        "input": function($event) {
          _vm.updateRegex(index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label",
      attrs: {
        "for": 'summary_' + index
      }
    }, [_vm._v("Summary regex")])]), _vm._v(" "), _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent del-regex",
      on: {
        "click": function($event) {
          _vm.deleteRegex(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete_forever")])]), _vm._v(" "), (_vm.errors[index]) ? _c('div', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.errors[index]))]) : _vm._e()])
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent add-regex",
    on: {
      "click": _vm.addRegex
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad9d8924","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/config/SummaryRegex.vue
// module id = 422
// module chunks = 1